import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};
export default function BottomHomeSlider() {
  return (
    <Carousel
      rtl={true}
      swipeable={true}
      draggable={true}
      showDots={false}
      responsive={responsive}
      infinite={false}
      itemClass={"item-class-bottom-responsive"}
      partialVisible={false}
      autoPlaySpeed={1000}
      keyBoardControl={true}
      transitionDuration={500}
      containerclassName="carousel-container"
      itemclassName="carousel-item-padding-40-px"
    >
      <div>
        <div className="bottom-home-item">
          <img src={"/images/bime-anbar-amn.svg"} alt={""} />
          <div className="carousel-item-content">
            بیمه و نگهداری در انبار اَمن
          </div>
        </div>
      </div>
      <div>
        <div className="bottom-home-item">
          <img
            src={"/images/income-outcome.svg"}
            alt={""}
            className="smaller"
          />
          <div className="carousel-item-content">واریز و برداشت فوری</div>
        </div>
      </div>
      <div>
        <div className="bottom-home-item">
          <img src={"/images/tazmin-24-ayar.svg"} alt={""} />
          <div className="carousel-item-content">تضمین عیار</div>
        </div>
      </div>
      <div>
        <div className="bottom-home-item">
          <img
            src={"/images/kharid-mizan-delkhah.svg"}
            alt={""}
            className="smaller"
          />
          <div className="carousel-item-content">خرید به میزان دلخواه</div>
        </div>
      </div>
      <div>
        <div className="bottom-home-item">
          <img
            src={"/images/svg/moamele-ba-gheymat-shoma.svg"}
            alt={""}
            className="smaller"
          />
          <div className="carousel-item-content">معامله با قیمت شما</div>
        </div>
      </div>
      <div>
        <div className="bottom-home-item">
          <img src={"/images/shabane-roozi.svg"} alt={""} className="smaller" />
          <div className="carousel-item-content">شبانه روزی هر روز هفته</div>
        </div>
      </div>
    </Carousel>
  );
}
